<onyx-section [heading]="`${I18N}.heading`">
  <div rightHeading class="heading" [class.error]="isInvalid()">
    <onyx-icon name="tooltip-filled" [size]="16"></onyx-icon>

    <p>{{ `${I18N}.requiredAbstract` | translate }}</p>
  </div>

  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-dropdown
      data-testid="issuing-country-dropdown"
      [formControl]="controls.issuingCountry"
      label="labels.issuingCountry"
      [options]="countries$ | async"
      [search]="true"
      width="180px"
      [size]="32"
    ></onyx-dropdown>

    <ng-container
      *ngTemplateOutlet="
        itemTemplate;
        context: {
          testId: 'community-license',
          hasSignal: hasCommunityLicense,
          control: controls.communityLicenseAbstractNumber,
          label: 'labels.communityLicenseAbstract' | translate,
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        itemTemplate;
        context: {
          testId: 'permit',
          hasSignal: hasPermit,
          control: controls.permitAbstractNumber,
          label: 'labels.permitAbstract' | translate,
        }
      "
    ></ng-container>
  </form>
</onyx-section>

<ng-template
  let-testId="testId"
  let-hasSignal="hasSignal"
  let-control="control"
  let-label="label"
  #itemTemplate
>
  <div class="item">
    <onyx-toggle
      [attr.data-testid]="`has-${testId}-toggle`"
      [label]="label"
      [checked]="hasSignal()"
      (checkedChange)="hasSignal.set($event)"
    ></onyx-toggle>

    @if (hasSignal()) {
      <onyx-text-field
        [attr.data-testid]="`${testId}-abstract-number-field`"
        [formControl]="control"
        placeholder="labels.number"
        textTransform="uppercase"
        [size]="32"
        width="180px"
        [showErrors]="false"
      ></onyx-text-field>
    }
  </div>
</ng-template>
